import {CardToken, PaymentStatus, PayUOrderResponse, SettlementApi, SettlementClientDto, SettlementDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {Button, Card, Col, Collapse, Divider, List, Modal, Result, Row, Space, Spin, Tag, Typography} from "antd";
import dayjs from "dayjs";
import PaymentStatusSelector, { ClientPaymentStatusSelector } from "../../components/paymentStatusSelector/paymentStatusSelector";
import { RoutingPaths, loadingSpin } from "../routing/routingContainer";
import { Link } from "react-router-dom";
import NewsCta from "../news/components/newsCta";
import styles from "./settlementListContainer.module.less"
import { useInjection } from "inversify-react";
import ApiService from "../../services/apiService";
import { useEffect, useRef, useState } from "react";
import PayuPaymentStatus from "../../components/payuPaymentStatus/payuPaymentStatus";
import { getOrganisationId } from "../../hooks/useCurrentOrganisation";
import useCurrentUserRoles from "../../hooks/useCurrentUserRoles";
import { AsyncButton, AsyncButtonPopconfirm } from "digimuth-components/dist";
import { Helmet } from "react-helmet";
import Title from "antd/lib/typography/Title";
import Fingerprint2 from "@fingerprintjs/fingerprintjs";
import { DeleteOutlined, InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Meta from "antd/lib/card/Meta";
import confirm from "antd/lib/modal/confirm";
import { useQueryParams } from "../../hooks/useQueryParams";
import { AxiosResponse } from "axios";

export default function ClientSettlementsList(props: SettlementsListProps) {

    return <Row justify="center" style={{ flex: 1 }}>
        <Col xs={22} md={20} lg={18} xxl={16}>
            <SavedCardsList />
            {props.isLoading ? loadingSpin : <SettlementList data={props.data} />}
        </Col>
    </Row>
}

function SavedCardsList() {

    const [cards, setCards] = useState<CardToken[] | null>();
    const [isAddingCard, setIsAddingCard] = useState(false);
    const [refReqId, setRefReqId] = useState<string>();
    const apiService = useInjection(ApiService);

    const { searchParams } = useQueryParams();

    const refreshCards = async () => {

        const response = await apiService.getApi(SettlementApi).apiSettlementPaymentMethodsGet();

        setCards(response.data.cardTokens);
    }

    useEffect(() => {
        refreshCards();
    }, []);

    const deleteCard = async (token: string) => {
        await apiService.getApi(SettlementApi).apiSettlementDeleteCardDelete(token);
        refreshCards();
    }

    useEffect(() => {
        const statusCode = searchParams.get("statusCode");

        if (statusCode === "SUCCESS") {
            Modal.success({
                title: "Karta dodana",
                content: "Karta została dodana pomyślnie"
            });
        }

        if (statusCode === "WARNING_CONTINUE_CVV") {
            Modal.error({
                title: "Konieczne uzupełnienie",
                content: "Podaj kod CVV karty i zatwierdź"
            });
            setRefReqId(searchParams.get("refReqId")!);
        }
    }, [searchParams]);

    return <>
        <Title>
            Twoje zapisane karty płatnicze
        </Title>
        <Spin spinning={!cards}>
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 3,
                    xxl: 3,
                  }}
                dataSource={cards!}
                renderItem={c => <List.Item key={c.value!}>
                        <Card actions={[<AsyncButtonPopconfirm
                            buttonProps={{icon: <DeleteOutlined />, type: "link"}}
                            onConfirm={() => deleteCard(c.value)}
                            title="Czy na pewno chcesz usunąć tę kartę płatniczą?"
                            okText="Ok"
                            cancelText="Anuluj"
                            danger
                        >Usuń</AsyncButtonPopconfirm>]}>
                            <Meta
                                style={{ height: 100 }}
                                avatar={<img style={{ maxWidth: 70 }} src={c.brandImageUrl!} alt={c.cardBrand!} />}
                                title={c.cardNumberMasked}
                                description={<Space direction="vertical">
                                    <span>{c.cardExpirationMonth + "/" + c.cardExpirationYear}</span>
                                    {c.preferred && <Tag color="success">Domyślna</Tag>}
                                    {c.status === "NEW" && <Tag color="processing">Nowa</Tag>}
                                    {c.status === "EXPIRED" && <Tag color="error">Wygasła</Tag>}
                                </Space>}
                            />
                        </Card>
                    </List.Item>}
            />
            {cards?.length === 0 && <Typography.Text><InfoCircleOutlined /> Zapisanie danych karty płatniczej umożliwi opłacanie rozliczeń jednym kliknięciem oraz automatyczne rozliczanie abonamentu</Typography.Text>}
            {!isAddingCard && <Button type="dashed" block icon={<PlusOutlined />} onClick={() => setIsAddingCard(true)}>Dodaj kartę płatniczą</Button>}
            {(isAddingCard || refReqId) && <AddCardForm refReqId={refReqId || undefined} onSaved={() => { setIsAddingCard(false); refreshCards(); setRefReqId(undefined) }} />}
        </Spin>
    </>
}

export function AddCardForm(props: { onSaved: () => any, refReqId?: string, saveCardRequest?: (token: string, fingerprint: string) => Promise<AxiosResponse<PayUOrderResponse, any>> }) {

    const [isPayuInitialized, setIsPayuInitialized] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const payuSdkForms = useRef<payu.PayU>(undefined)
    const apiService = useInjection(ApiService);

    const onScriptLoaded = async () => {

        await waitForGlobal("PayU" as any);

        var optionsForms: payu.SecureFormOptions = {
            cardIcon: true,
            style: {
              basic: {
                fontSize: "16px",
                fontWeight: "normal",
                fontFamily: "Lato",
              },
            },
            placeholder: {
              number: "0000 0000 0000 0000 0000",
              date: "MM/RR",
              cvv: "000",
            },
            lang: "pl",
          };
          
          //inicjalizacja SDK poprzez podanie POS ID oraz utworzenie obiektu secureForms
          payuSdkForms.current = PayU("4352576");
          var secureForms = payuSdkForms.current.secureForms({ fonts: [{ family: "Lato", style: "normal", weight: 400, src: "url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXiWtFCc.woff2) format('woff2')" }] });
          
          if (!props.refReqId) {
            var cardNumber = secureForms.add("number", optionsForms);
            var cardDate = secureForms.add("date", optionsForms);

            cardNumber.render("#payu-card-number");
            cardDate.render("#payu-card-date");
          }

          var cardCvv = secureForms.add("cvv", optionsForms);
          
          cardCvv.render("#payu-card-cvv");
          setIsPayuInitialized(true);
    }

    useEffect(() => {
        onScriptLoaded();
    }, []);

    const onSuccess = async (token: string) => {
        try {
            const components = await Fingerprint2.getPromise();

            const fingerprint = Fingerprint2.x64hash128(components.map(c => c.value).join(""), 31);

            const response = await (props.saveCardRequest ? props.saveCardRequest(token, fingerprint) : apiService.getApi(SettlementApi).apiSettlementSaveCardPost(token, fingerprint));

            if (response.data.status?.statusCode === "WARNING_CONTINUE_3DS" && response.data.redirectUri) {
                confirm({
                    closable: false,
                    title: "Weryfikacja karty",
                    content: "Przekierowujemy Cię do strony Twojego banku, gdzie potwierdzisz zapisanie karty",
                    okButtonProps: { style: { display: "none" } },
                    cancelButtonProps: { style: { display: "none" } }
                });

                setTimeout(() => {
                    window.location.href = response.data.redirectUri!;
                }, 1000);

                return;
            }

            if (response.data.status?.statusCode === "WARNING_CONTINUE_CVV") {
                const refReqId = payuSdkForms.current?.extractRefReqId(response.data.redirectUri!);

                const result = await payuSdkForms.current?.sendCvv(refReqId!);

                result!.status !== "SUCCESS" && setError(result!.error.messages.map(m => m.message).join(", "));

                return;
            }

            props.onSaved();
        } catch (e: any) {
            setError(e.response.message);
        } finally {
            setIsLoading(false);
        }
    }

    const onSubmit = async () => {
        try {
            if (props.refReqId) {
              const result = await payuSdkForms.current?.sendCvv(props.refReqId);

              result!.status === "SUCCESS" ? props.onSaved() : setError(result!.error.messages.map(m => m.message).join(", "));

              return;
            }

            const result = await payuSdkForms.current!.tokenize("MULTI");

            result.status === "SUCCESS"
                ? onSuccess(result.body.token)
                : setError(result.error.messages.map(m => m.message).join(", "));
          } catch (e) {
            console.log(e); // błędy techniczne
          }
    }

    return <>
        <Helmet script={[{ src: "https://secure.payu.com/javascript/sdk", type: "text/javascript" }]} />
        <Spin spinning={!isPayuInitialized || isLoading} className="payu-container">
            <div className="card-container">
                {!props.refReqId && <><aside>Numer karty</aside>
                <div className="payu-card-form ant-input" id="payu-card-number"></div></>}

                <div style={{ display: "flex", gap: "20px" }}>
                    {!props.refReqId && <div className="expiration" style={{ flex: 2 }}>
                        <aside>Data ważności</aside>
                        <div className="payu-card-form ant-input" id="payu-card-date"></div>
                    </div>}

                    <div className="cvv" style={{ flex: 1 }}>
                        <aside>CVV</aside>
                        <div className="payu-card-form ant-input" id="payu-card-cvv"></div>
                    </div>
                </div>
            </div>
            <AsyncButton type="primary" onClick={onSubmit} style={{ marginBottom: 10 }}>Zapisz</AsyncButton>

            <Typography.Text type="danger">{error}</Typography.Text>
        </Spin>
        <Typography.Paragraph type="secondary" style={{ fontSize: 12 }}>
        Zlecenie realizacji płatności: Zlecenie wykonuje PayU SA; Dane odbiorcy, tytuł oraz kwota płatności dostarczane są PayU SA przez odbiorcę; Zlecenie jest przekazywane do realizacji po otrzymaniu przez PayU SA Państwa wpłaty. Płatność udostępniana jest odbiorcy w ciągu 1 godziny, nie później niż do końca następnego dnia roboczego; PayU SA nie pobiera opłaty od realizacji usługi.
</Typography.Paragraph>
<Typography.Paragraph type="secondary" style={{ fontSize: 12 }}>
Płacąc akceptujesz <a href="https://static.payu.com/sites/terms/files/payu_terms_of_service_single_transaction_pl_en.pdf">PayU Payment Terms.</a>
</Typography.Paragraph>
<Typography.Paragraph type="secondary" style={{ fontSize: 12 }}>
Administratorem Twoich danych osobowych jest PayU S.A. z siedzibą w Poznaniu (60-166), przy ul. Grunwaldzkiej 186. Twoje dane osobowe będą przetwarzane w celu realizacji transakcji płatniczej, powiadamiania Cię o statusie realizacji Twojej płatności, rozpatrywania reklamacji, a także w celu wypełnienia obowiązków prawnych ciążących na PayU.
</Typography.Paragraph>
<Typography.Paragraph type="secondary" style={{ fontSize: 12 }} ellipsis={{ rows: 0, expandable: true, symbol: "Czytaj więcej" }}>
Odbiorcami Twoich danych osobowych mogą być podmioty współpracujące z PayU w procesie realizacji płatności. W zależności od wybranej przez Ciebie metody płatności mogą to być: banki, instytucje płatnicze, instytucje pożyczkowe, organizacje kart płatniczych, schematy płatnicze), ponadto podmioty wspierające działalność PayU tj. dostawcy infrastruktury IT, dostawcy narzędzi do analizy ryzyka płatności a także podmiotom uprawnionym do ich otrzymania na mocy obowiązujących przepisów prawa, w tym właściwym organom wymiaru sprawiedliwości. Twoje dane mogą zostać udostępnione akceptantom celem poinformowania ich o statusie realizacji płatności. Przysługuje Tobie prawo dostępu do danych, a także do ich sprostowania, ograniczenia ich przetwarzania, zgłoszenia sprzeciwu wobec ich przetwarzania, niepodlegania zautomatyzowanemu podejmowaniu decyzji w tym profilowania oraz do przenoszenia i usunięcia danych. Podanie danych jest dobrowolne jednak niezbędne do realizacji płatności, a brak podania danych może skutkować odrzuceniem płatności. Więcej informacji o zasadach przetwarzania Twoich danych osobowych przez PayU znajdziesz w <a href="https://static.payu.com/sites/terms/files/payu_privacy_policy_pl_pl.pdf">Polityce Prywatności</a>.
        </Typography.Paragraph>
    </>
}

function waitForGlobal(name: keyof Window, timeout = 300) {
    return new Promise<void>((resolve, reject) => {
      let waited = 0
  
      function wait(interval: number) {
        setTimeout(() => {
          waited += interval
          // some logic to check if script is loaded
          // usually it something global in window object 
          if (window[name] !== undefined) {
            return resolve()
          }
          if (waited >= timeout * 1000) {
            return reject({ message: 'Timeout' })
          }
          wait(interval * 2)
        }, interval)
      }
  
      wait(30)
    })
  }

function SettlementList(props: { data?: SettlementClientDto[] | null }) {

    const apiService = useInjection(ApiService);
    const [isLoading, setIsLoading] = useState(false);

    const beginPayment = async (id: number) => {
        setIsLoading(true);

        try {
            const response = await apiService.getApi(SettlementApi).apiSettlementPaymentPost({ settlementId: id, currentUrl: window.location.href });

            if (response.data.paymentUrl) {
                window.location.href = response.data.paymentUrl;
            }
        } finally {
            setIsLoading(false);
        }
    }

    if (!props.data?.length) {
        return <Row>
            <Col xs={24} md={12} lg={14} xl={16}>
                <Result title="Wygląda na to, że nie masz opublikowanych żadnych rozliczeń w systemie"/>
            </Col>
            <Col xs={24} sm={{span: 20, offset: 2}} md={{span: 12, offset: 0}} lg={10} xl={8}>
                <NewsCta/>
            </Col>
        </Row>
    }

    const today = dayjs(new Date());

    const notPaid = props.data.filter(s => s.paymentStatus !== PaymentStatus.Paid);
    const afterDeadline = notPaid.filter(s => today.isAfter(dayjs(s.paymentDueDate), "day"));
    const toPay = notPaid.filter(s => !afterDeadline.includes(s));
    const paid = props.data.filter(s => s.paymentStatus === PaymentStatus.Paid);

    const ListInternal = (p: { data: SettlementClientDto[] }) => {
        return <List
            dataSource={p.data || undefined}
            renderItem={s => <List.Item key={s.id!}><SettlementClientCard settlement={s} beginPayment={beginPayment} /></List.Item>}
            grid={{ 
                gutter: 24,
                column: 3,
                xs: 1,
                sm: 1,
                md: 1,
                lg: 1,
                xl: 1,
                xxl: 2
            }}
        />
    }

    return <Spin spinning={isLoading}>
        <Collapse className={styles.collapseWrapper} defaultActiveKey={["afterDeadline", "toPay", "paid"]} ghost>
            <Panel key="afterDeadline" header={`Po terminie płatności (${afterDeadline.reduce((a, b) => a + (b.grossAmount || 0), 0)} zł)`}>
                <ListInternal data={afterDeadline} />
            </Panel>
            <Panel key="toPay" header={`Do zapłaty (${toPay.reduce((a, b) => a + (b.grossAmount || 0), 0)} zł)`}>
                <ListInternal data={toPay} />
            </Panel>
            <Panel key="paid" header={`Opłacono (${paid.reduce((a, b) => a + (b.grossAmount || 0), 0)} zł)`}>
                <ListInternal data={paid} />
            </Panel>
        </Collapse>
    </Spin>
}

const { Panel } = Collapse;

const { Text } = Typography;

export function SettlementClientCard(props: { settlement: SettlementClientDto, beginPayment?: (id: number) => any }) {
    const settlement = props.settlement;

    return <Link to={RoutingPaths.yourCaseDetails.route.replace(":id", settlement.caseId!.toString())}>
        <Card title={<Space wrap split={<Divider type="vertical" />}>
                <div>{dayjs(settlement.issueDate!).format("YYYY-MM-DD")}</div>
                <div>Do zapłaty: {settlement.grossAmount} zł</div>
                {!getOrganisationId() && settlement.paymentStatus === PaymentStatus.InvoiceIssued
                && (!settlement.payuStatus || settlement.payuStatus === "CANCELED")
                && props.beginPayment
                && <AsyncButtonPopconfirm title={<>Klikając "Zapłać" potwierdzasz akceptację <a target="_blank" style={{ color: "#C19966", fontWeight: "bold" }} href="https://gwexperts.pl/terms-and-conditions/">Regulaminu Platformy GoodNet</a>. Płatność realizowana przez PayU</>} okText="Zapłać" cancelText="Anuluj" onConfirm={() => { props.beginPayment(settlement.id!);}} type="primary">Zapłać</AsyncButtonPopconfirm>}
            </Space>}>
            <Space direction="vertical" style={{ width: "100%" }}>
                <Space>
                    <Text type="secondary">Kwota netto: </Text>
                    <Text>{settlement.amountDue} zł</Text>
                </Space>
                <Space>
                    <Text type="secondary">Sprawa: </Text>
                    <Text>{settlement.case!.name}</Text>
                </Space>
                {props.beginPayment && <Space>
                    <Text type="secondary">Numer faktury: </Text>
                    <Text>{settlement.invoiceNumber}</Text>
                </Space>}
                {props.beginPayment && <Space>
                    <Text type="secondary">Termin płatności: </Text>
                    <Text>{dayjs(settlement.paymentDueDate!).format("YYYY-MM-DD")}</Text>
                </Space>}
                <Space>
                    <Text type="secondary">Data zapłaty: </Text>
                    <> {settlement.paymentDate ? dayjs(settlement.paymentDate).format("YYYY-MM-DD") : null} </>
                </Space>
                <Space>
                    <Text type="secondary">Status płatności: </Text>
                    <ClientPaymentStatusSelector value={settlement.paymentStatus} editable={false} />
                </Space>
                <Space>
                    <Text type="secondary">Płatność elektroniczna: </Text>
                    <PayuPaymentStatus value={settlement.payuStatus} />
                </Space>
            </Space>
        </Card>
    </Link>
}

interface SettlementsListProps extends CrudTableWrapperProps<SettlementDto> {
}
